import TIK from 'constants/time/timeIntervalKind.const';

const TIME_INTERVAL_LABEL = Object.freeze({
  [TIK.monthToDate]: 'staffKpisReports.kpiReports.rangeFilter.monthToDate',
  [TIK.monthLast]: 'staffKpisReports.kpiReports.rangeFilter.monthLast',
  [TIK.monthThis]: 'staffKpisReports.kpiReports.rangeFilter.monthThis',
  [TIK.monthNext]: 'staffKpisReports.kpiReports.rangeFilter.monthNext',
  [TIK.weekToDate]: 'staffKpisReports.kpiReports.rangeFilter.weekToDate', // new
  [TIK.weekLast]: 'staffKpisReports.kpiReports.rangeFilter.weekLast',
  [TIK.weekThis]: 'staffKpisReports.kpiReports.rangeFilter.weekThis',
  [TIK.weekNext]: 'staffKpisReports.kpiReports.rangeFilter.weekNext',
  [TIK.dayYester]: 'staffKpisReports.kpiReports.rangeFilter.dayYesterday',
  [TIK.dayToday]: 'staffKpisReports.kpiReports.rangeFilter.dayToday',
  [TIK.dayMorrow]: 'staffKpisReports.kpiReports.rangeFilter.dayTomorrow',
});

export default TIME_INTERVAL_LABEL;
